/* Sea Dragon Dreams: premium layer behaviours (progressive enhancement; the theme works without it). */
(function () {
  'use strict';
  var SDD = (window.SDD = window.SDD || {});
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Reveal on scroll ---------- */
  SDD.reveal = function (root) {
    if (document.body.getAttribute('data-sdd-reveal') !== 'true') return;
    var nodes = (root || document).querySelectorAll('.sdd-reveal:not(.is-in)');
    if (reduceMotion || !('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.classList.add('is-in'); });
      return;
    }
    if (!SDD._io) {
      SDD._io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); SDD._io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    }
    nodes.forEach(function (n) { SDD._io.observe(n); });
  };

  /* ---------- Free shipping bar ---------- */
  function formatMoney(cents) {
    if (window.theme && theme.Currency && theme.Currency.formatMoney) {
      return theme.Currency.formatMoney(cents, (window.theme.settings && theme.settings.moneyFormat) || SDD.ship.moneyFormat);
    }
    return '$' + (cents / 100).toFixed(2);
  }
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  SDD.updateShip = function (cart) {
    var cfg = SDD.ship;
    if (!cfg || !cfg.enabled || !cfg.threshold) return;
    var rate = (window.Shopify && Shopify.currency && Number(Shopify.currency.rate)) || 1;
    var threshold = Math.round(cfg.threshold * rate);
    var total = cart.total_price || 0;
    var remaining = Math.max(threshold - total, 0);
    var pct = Math.min(100, Math.round((total / threshold) * 100));
    document.querySelectorAll('[data-sdd-ship]').forEach(function (el) {
      el.style.setProperty('--sdd-ship-pct', pct + '%');
      el.classList.toggle('is-complete', remaining === 0);
      var bar = el.querySelector('[role="progressbar"]');
      if (bar) bar.setAttribute('aria-valuenow', pct);
      var msg = el.querySelector('[data-sdd-ship-msg]');
      if (msg) {
        msg.innerHTML = remaining === 0
          ? escapeHtml(cfg.success)
          : escapeHtml(cfg.progress).replace('[amount]', '<strong>' + formatMoney(remaining) + '</strong>');
      }
    });
  };
  /* Apply server-rendered progress without inline styles */
  document.querySelectorAll('[data-sdd-ship][data-pct]').forEach(function (el) {
    el.style.setProperty('--sdd-ship-pct', el.getAttribute('data-pct') + '%');
  });
  function refreshShip() {
    if (!document.querySelector('[data-sdd-ship]')) return;
    fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(SDD.updateShip)
      .catch(function () {});
  }
  document.addEventListener('cart:updated', function (e) {
    if (e.detail && e.detail.cart) SDD.updateShip(e.detail.cart); else refreshShip();
  });
  document.addEventListener('ajaxProduct:added', refreshShip);

  /* ---------- Lightweight scroll-snap carousel controls ---------- */
  SDD.carousels = function (root) {
    (root || document).querySelectorAll('[data-sdd-carousel]:not([data-ready])').forEach(function (wrap) {
      wrap.setAttribute('data-ready', '');
      var track = wrap.querySelector('[data-sdd-track]');
      var prev = wrap.querySelector('[data-sdd-prev]');
      var next = wrap.querySelector('[data-sdd-next]');
      if (!track) return;
      function step() {
        var item = track.querySelector(':scope > *');
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return item ? item.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
      }
      function sync() {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: reduceMotion ? 'auto' : 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: reduceMotion ? 'auto' : 'smooth' }); });
      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });
  };

  /* ---------- Hero slideshow (sections/sdd-hero.liquid) ---------- */
  SDD.heroes = function (root) {
    (root || document).querySelectorAll('[data-sdd-hero]:not([data-ready])').forEach(function (hero) {
      hero.setAttribute('data-ready', '');
      var slides = hero.querySelectorAll('[data-sdd-slide]');
      var dots = hero.querySelectorAll('[data-sdd-dot]');
      if (slides.length < 2) { if (slides[0]) slides[0].classList.add('is-active'); return; }
      var i = 0, timer = null;
      var delay = parseInt(hero.getAttribute('data-autoplay'), 10) || 0;
      function go(n) {
        slides[i].classList.remove('is-active'); slides[i].setAttribute('aria-hidden', 'true');
        if (dots[i]) { dots[i].classList.remove('is-active'); dots[i].setAttribute('aria-current', 'false'); }
        i = (n + slides.length) % slides.length;
        slides[i].classList.add('is-active'); slides[i].setAttribute('aria-hidden', 'false');
        if (dots[i]) { dots[i].classList.add('is-active'); dots[i].setAttribute('aria-current', 'true'); }
        slides.forEach(function (s, idx) {
          s.querySelectorAll('a, button').forEach(function (el) { el.tabIndex = idx === i ? 0 : -1; });
          var v = s.querySelector('video');
          if (v) { if (idx === i) { v.play && v.play().catch(function () {}); } else { v.pause && v.pause(); } }
        });
      }
      function play() { if (delay && !reduceMotion) { stop(); timer = setInterval(function () { go(i + 1); }, delay * 1000); } }
      function stop() { if (timer) clearInterval(timer); timer = null; }
      dots.forEach(function (d, idx) { d.addEventListener('click', function () { go(idx); play(); }); });
      var p = hero.querySelector('[data-sdd-hero-prev]'), n = hero.querySelector('[data-sdd-hero-next]');
      if (p) p.addEventListener('click', function () { go(i - 1); play(); });
      if (n) n.addEventListener('click', function () { go(i + 1); play(); });
      hero.addEventListener('mouseenter', stop); hero.addEventListener('mouseleave', play);
      hero.addEventListener('focusin', stop); hero.addEventListener('focusout', play);
      var sx = null;
      hero.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      hero.addEventListener('touchend', function (e) {
        if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; sx = null;
        if (Math.abs(dx) > 40) { go(dx < 0 ? i + 1 : i - 1); play(); }
      });
      go(0); play();
    });
  };

  /* ---------- Testimonials / tabs: simple accessible tabs ---------- */
  SDD.tabs = function (root) {
    (root || document).querySelectorAll('[data-sdd-tabs]:not([data-ready])').forEach(function (wrap) {
      wrap.setAttribute('data-ready', '');
      var tabs = wrap.querySelectorAll('[role="tab"]');
      tabs.forEach(function (tab, idx) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t) {
            var on = t === tab;
            t.setAttribute('aria-selected', on);
            t.tabIndex = on ? 0 : -1;
            var panel = document.getElementById(t.getAttribute('aria-controls'));
            if (panel) panel.hidden = !on;
          });
        });
        tab.addEventListener('keydown', function (e) {
          var dir = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (!dir) return;
          var nxt = tabs[(idx + dir + tabs.length) % tabs.length];
          nxt.focus(); nxt.click();
        });
      });
    });
  };

  /* ---------- Long collection descriptions: collapse with "Read more" (text stays in the DOM for SEO) ---------- */
  SDD.readMore = function (root) {
    (root || document).querySelectorAll('.collection__description:not([data-sdd-rm])').forEach(function (el) {
      el.setAttribute('data-sdd-rm', '');
      if (el.scrollHeight < 190) return;
      var id = 'sdd-desc-' + Math.random().toString(36).slice(2, 8);
      el.id = el.id || id;
      el.classList.add('sdd-clamp');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'sdd-link sdd-readmore';
      btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('aria-controls', el.id);
      btn.textContent = el.getAttribute('data-more') || 'Read more';
      btn.addEventListener('click', function () {
        var open = el.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open);
        btn.textContent = open ? (el.getAttribute('data-less') || 'Show less') : (el.getAttribute('data-more') || 'Read more');
      });
      el.insertAdjacentElement('afterend', btn);
    });
  };

  /* ---------- FAQ pages: turn headings in page content into accessible accordions ---------- */
  SDD.accordions = function (root) {
    (root || document).querySelectorAll('[data-sdd-accordion]:not([data-ready])').forEach(function (body) {
      body.setAttribute('data-ready', '');
      var lvl = body.getAttribute('data-sdd-accordion');
      if (lvl === 'auto') {
        lvl = ['h2', 'h3', 'h4'].filter(function (h) { return body.querySelectorAll(':scope > ' + h).length > 1; })[0];
      }
      if (!lvl) return;
      var heads = body.querySelectorAll(':scope > ' + lvl);
      heads.forEach(function (h) {
        var details = document.createElement('details');
        details.className = 'sdd-faq';
        var summary = document.createElement('summary');
        summary.className = 'sdd-faq__q';
        summary.innerHTML = h.innerHTML;
        var panel = document.createElement('div');
        panel.className = 'sdd-faq__a';
        var stopRank = parseInt(lvl.charAt(1), 10);
        var n = h.nextElementSibling;
        while (n) {
          var m = /^H([1-6])$/.exec(n.tagName);
          if (m && parseInt(m[1], 10) <= stopRank) break;
          var next = n.nextElementSibling;
          panel.appendChild(n);
          n = next;
        }
        details.appendChild(summary); details.appendChild(panel);
        h.replaceWith(details);
      });
      body.classList.add('is-accordion');
    });
  };

  function init(root) {
    SDD.accordions(root);
    SDD.reveal(root); SDD.carousels(root); SDD.heroes(root); SDD.tabs(root); SDD.readMore(root);
  }
  document.addEventListener('collection:reloaded', function () { SDD.readMore(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); refreshShip(); });
  else { init(); refreshShip(); }

  /* Theme editor support */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest && e.target.closest('[data-sdd-slide]');
    if (slide) {
      var hero = slide.closest('[data-sdd-hero]');
      var dots = hero && hero.querySelectorAll('[data-sdd-dot]');
      var idx = Array.prototype.indexOf.call(hero.querySelectorAll('[data-sdd-slide]'), slide);
      if (dots && dots[idx]) dots[idx].click();
    }
    e.target.classList && e.target.classList.add('is-in');
  });
})();
